var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlBuffetRestaurantFilled = function SvgHtlBuffetRestaurantFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 13.5v-2.406a.093.093 0 0 1 .094-.094h2.813a.094.094 0 0 1 .094.094V13.5a1.5 1.5 0 1 1-3.001 0Zm-5.907-.176.427-5.973a.246.246 0 0 0-.168-.251 1.976 1.976 0 0 1-1.341-2.071l.6-3.735a.294.294 0 0 1 .587.03l-.223 3.037a.56.56 0 1 0 1.12 0v-2.24a.56.56 0 0 1 1.121 0v2.24a.56.56 0 0 0 1.12 0l-.192-3.066a.294.294 0 0 1 .586-.029L8.3 5.03a1.976 1.976 0 0 1-1.342 2.071.246.246 0 0 0-.168.251l.427 5.973a1.564 1.564 0 1 1-3.12 0l-.004-.001ZM9.236 10a.236.236 0 0 1-.235-.236v-5A3.764 3.764 0 0 1 12.766.999a.235.235 0 0 1 .235.235v8.529a.236.236 0 0 1-.235.236L9.236 10Z"
  })));
};
export default SvgHtlBuffetRestaurantFilled;